import { ComponentType } from 'react'

import { TFunctionDetailedResult } from 'i18next'
import styled, { CSSProperties } from 'styled-components'
import {
  BorderRadiusProps,
  borderRadius,
  color,
  FontFamilyProps,
  FontSizeProps,
  FontStyleProps,
  FontWeightProps,
  fontFamily,
  fontSize,
  fontStyle,
  fontWeight,
  LayoutProps,
  LetterSpacingProps,
  LineHeightProps,
  layout,
  letterSpacing,
  lineHeight,
  SizeProps,
  SpaceProps,
  size,
  space,
  system,
  TextAlignProps,
  TextStyleProps,
  textAlign,
  textStyle,
} from 'styled-system'

import { filterStyledSystemProps } from '@/helpers/styled-props'
import { Color } from '@/styles'

type Children = React.ReactNode | TFunctionDetailedResult

type StyledSystemBaseProps = FontSizeProps &
  FontStyleProps &
  SizeProps &
  TextStyleProps &
  LetterSpacingProps &
  FontFamilyProps &
  FontWeightProps &
  BorderRadiusProps &
  LineHeightProps &
  TextAlignProps &
  SpaceProps &
  LayoutProps & {
    textTransform?: string
    textOverflow?: string
    whiteSpace?: string
    wordBreak?: string
    htmlFor?: string
    onMouseEnter?: () => void
    onMouseLeave?: () => void
    title?: string | number
    cursor?: string
    style?: CSSProperties
    color?: Color
    as?: keyof React.JSX.IntrinsicElements | ComponentType<any>
  }

export type StyledSystemProps = StyledSystemBaseProps & { children?: Children }

const DynamicStyledSystemComponent = styled.div.withConfig({
  shouldForwardProp: filterStyledSystemProps('cursor'),
})`
  display: inline-block;
  ${space}
  ${fontSize}
  ${fontStyle}
  ${size}
  ${color}
  ${layout}
  ${textStyle}
  ${letterSpacing}
  ${fontFamily}
  ${fontWeight}
  ${borderRadius}
  ${lineHeight}
  ${textAlign}
  ${system({ textTransform: true, whiteSpace: true, textOverflow: true, cursor: true, wordBreak: true })}
`

export default DynamicStyledSystemComponent
